<template lang="pug">
Label(:tipo='tipo' :estilo='definirEstilo(codigo)', :texto='definirSituacao(codigo)')
</template>

<script>
import Label from '@/components/labels/Label.vue';
import LaudoUtils from '@/utils/LaudoUtils';

export default {
    name: 'LabelLaudoSituacao',

    components: {
        Label
    },

    props: {
        tipo: {
            type: String,
            required: true
        },
        codigo: {
            type: String,
            require: true
        }
    },

    methods: {
        definirEstilo(codigo) {
            return LaudoUtils.definirEstilo(codigo);
        },
        
        definirSituacao(codigo) {
            return LaudoUtils.definirSituacao(codigo);
        }
    }
};
</script>

<style lang="scss" scoped></style>
